import uaParser from 'ua-parser-js';

const uaParsed = uaParser(window.navigator.userAgent);
export const isStandalone = !!window.navigator.standalone;
export const isIos = uaParsed && uaParsed.os && uaParsed.os.name === 'iOS';
export const isMacOs = uaParsed && uaParsed.os && uaParsed.os.name === 'Mac OS';
export const isWindows = uaParsed && uaParsed.os && uaParsed.os.name.includes('Windows');
export const isAndroid = uaParsed && uaParsed.os && uaParsed.os.name === 'Android';
export const isIE = uaParsed && uaParsed.browser && (uaParsed.browser.name === 'IE' || uaParsed.browser.name === 'IEMobile');
export const isEdge = uaParsed && uaParsed.browser && uaParsed.browser.name === 'Edge';
export const iOSWrapper = window.navigator.userAgent && window.navigator.userAgent.includes('iOSWrapper');
export const androidWrapper = window.navigator.userAgent && window.navigator.userAgent.includes('AndroidWrapper');
export const isWrapperApp = androidWrapper || iOSWrapper;
export const getWrapperForTracking = () => {
  if (iOSWrapper) return 'iOS';
  if (androidWrapper) return 'Android';
  return 'None';
};

export const isTablet = uaParsed && uaParsed.device && uaParsed.device.type === 'tablet';

export const getOrientation = () => {
  if (window.screen.orientation) {
    if (window.screen.orientation.type.includes('portrait')) return 'portrait';
    return 'landscape';
  }
  if (Math.abs(window.orientation) === 90) return 'landscape';
  return 'portrait';
};

const userAgentMixin = {
  computed: {
    isTablet() {
      return isTablet;
    },
    isWindows() {
      return isWindows;
    },
    isIos() {
      return isIos;
    },
    isMacOs() {
      return isMacOs;
    },
    isStandalone() {
      return isStandalone;
    },
    isAndroid() {
      return isAndroid;
    },
    isIE() {
      return isIE;
    },
    iOSWrapper() {
      return iOSWrapper;
    },
    isEdge() {
      return isEdge;
    },
    androidWrapper() {
      return androidWrapper;
    },
    isWrapperApp() {
      return isWrapperApp;
    },
    version() {
      return '1.0.67';
    },
  },
  methods: {
    getWindowSize() {
      return [
        Math.min(document.documentElement.clientWidth, window.innerWidth || 0),
        Math.min(document.documentElement.clientHeight, window.innerHeight || 0),
      ];
    },
    getOrientation() {
      return getOrientation();
    },
  },
};


export default userAgentMixin;



// WEBPACK FOOTER //
// ./src/mixins/userAgent.js